import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ErrorCode } from '../../shared/error-codes';
import { PasswordSchema } from '../../shared/password-validation';
/**
 * Change Password Request Schema
 * POST /api/v2/profile/change-password
 * Allows users to change their password
 */ export const ChangePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    newPassword: PasswordSchema,
    confirmPassword: z.string().min(1, ErrorCode.FIELD_REQUIRED)
}).refine((data)=>data.newPassword === data.confirmPassword, {
    message: ErrorCode.FIELD_PASSWORDS_MISMATCH,
    path: [
        'confirmPassword'
    ]
});
/**
 * Change Password Response Schema
 */ export const ChangePasswordResponseSchema = z.object({
    success: z.boolean()
});
/**
 * Change Password Error Schema
 */ export const ChangePasswordErrorSchema = BaseErrorSchema;

//# sourceMappingURL=change-password.schema.js.map